import CoreInstance from '../CoreInstance';
import { getTransformOpts } from '../adapters/transforms';
import { getCategoriesAdapter, getSubcategoriesAdapter, getResourcesAdapter } from '../adapters/resources';
import i18n from 'i18n';
import { localeFlag, getHeadersWithTokens, setParam } from 'api/ApiHelpers';


export interface IResources {
  getResourcesTabs(): any;

  getCategories(folderId: number, page: number, filter?: boolean): any;
  postCategory(folderId: number, data: any): any;
  deleteCategory(id: number): any;
  getCategory(id: number): any;

  getSubcategories(folderId: number, page?: number, filter?: boolean,): any;
  postSubcategory(folderId: number, data: any): any;
  deleteSubcategory(id: number): any;
  getSubcategory(id: number): any;

  getResources(folderId: number, page: number): any;
  postResource(folderId: number, data: any): any;
  deleteResource(folderId: number, id: number): any;
  getResource(id: number): any;
  updateResource(folderId: number, resourceId: number, data: any): any;

  postShareResource(folderId: number, resourceId: number, data: { scope: string, babies: number[] }): void;
}

const centers: IResources = {
  getResourcesTabs: () => CoreInstance.get(`centers/tabs?${localeFlag()}`, getHeadersWithTokens()),
  getCategories: (folderId, page, filter = false) =>
    CoreInstance.get(`/centers/folders/${folderId}/categories?my_category=${filter ? 'true' : 'false'}&per_page=10${setParam('page', page)}`,
      { ...getHeadersWithTokens(), ...getTransformOpts(getCategoriesAdapter) }),
  postCategory: (folderId, data) => CoreInstance.post(`/centers/folders/${folderId}/categories?${localeFlag(i18n.language)}`, data, getHeadersWithTokens(true)),
  deleteCategory: (id) => CoreInstance.delete(`/centers/categories/${id}`, getHeadersWithTokens(true)),
  getCategory: (id) => CoreInstance.get(`/centers/folders/${id}`, getHeadersWithTokens()),

  getSubcategories: (folderId, page = 1, filter = false) =>
    CoreInstance.get(`/centers/folders/${folderId}/subcategories?per_page=10&page=${page}&my_category=${filter}`,
      { ...getHeadersWithTokens(), ...getTransformOpts(getSubcategoriesAdapter) }),
  postSubcategory: (folderId, data) => CoreInstance.post(`/centers/folders/${folderId}/subcategories`, data, getHeadersWithTokens()),
  deleteSubcategory: (id) => CoreInstance.delete(`/centers/subcategories/${id}`, getHeadersWithTokens()),
  getSubcategory: (id) => CoreInstance.get(`/centers/folders/${id}`, getHeadersWithTokens()),

  getResources: (folderId, page) => CoreInstance.get(`/centers/folders/${folderId}/resources?per_page=10&page=${page}&${localeFlag()}`, {
    ...getHeadersWithTokens(),
    ...getTransformOpts(getResourcesAdapter),
  }),
  postResource: (folderId, data) => CoreInstance.post(`/centers/folders/${folderId}/resources`, data, getHeadersWithTokens()),
  deleteResource: (folderId, id) => CoreInstance.delete(`/centers/folders/${folderId}/resources/${id}`, getHeadersWithTokens()),
  getResource: (id) => CoreInstance.get(`/centers/folders/${id}`, getHeadersWithTokens()),
  updateResource: (folderId, resourceId, data) =>
    CoreInstance.put(`/centers/folders/${folderId}/resources/${resourceId}`, data, getHeadersWithTokens()),
  postShareResource: (folderId, resourceId, data) =>
    CoreInstance.post(`/centers/folders/${folderId}/resources/${resourceId}/share`, data, getHeadersWithTokens()),
};

export default {
  centers,
};
